import GaelleSing1  from '../../images/serrage.jpg';

import getMessage   from '../../global/getMessage';

// eslint-disable-next-line import/prefer-default-export
export const productFormation = (lang) => [
  {
    id          : 0,
    title       : getMessage('section.shop.product.formation.voie.title',lang),
    description : getMessage('section.shop.product.formation.voie.description',lang),
    price       : 119,
    priceEuro   : 99,
    img         : GaelleSing1,
    promoCode   : [
      {
        code   : 'first10%',
        rebate : 10, // percentage
      },
      // {
      //   code   : 'new25%',
      //   rebate : 25, // percentage
      // },
      {
        code   : 'all$100%',
        rebate : 99.9, // percentage
      },
    ],
    videos: [
      {
        title : 'La voie de la bonne voix',
        src   : 'https://www.youtube.com/watch?v=mn1w_nEt-Ec',
      },
    ],
    contentTemplate : 'lavoiedelabonnevoix',
    atm             : [
      'Bienvenue-La-voie-de-la-bonne-voix.pdf',
      'Introduction-La-voie-de-la-bonne voix.pdf',
      'Liberer-votre-voix-Trucs-et-Astuces.pdf',
      'Quiz-Prise-de-parole-en-public.pdf',
      'Quiz-Correction-Prise-de-parole-en-public.pdf',
      'Bonus-La-minute-defis.pdf',
      'Bonus-Ma-routine-vocale.pdf',
      'Le-serrage-larynge-Gaelle-Boudier-La-voie-de-la-bonne-voix.mp3',
      'La-prise-de-parole-en-public-Gaelle-Boudier.pdf',
    ],
  },
];

export const europeanCodeList = {
  'AT' : 'AT',
  'BE' : 'BE',
  'BG' : 'BG',
  'HR' : 'HR',
  'CY' : 'CY',
  'CZ' : 'CZ',
  'DK' : 'DK',
  'EE' : 'EE',
  'FI' : 'FI',
  'FR' : 'FR',
  'DE' : 'DE',
  'GR' : 'GR',
  'HU' : 'HU',
  'IE' : 'IE',
  'IT' : 'IT',
  'LV' : 'LV',
  'LT' : 'LT',
  'LU' : 'LU',
  'MT' : 'MT',
  'NL' : 'NL',
  'PL' : 'PL',
  'PT' : 'PT',
  'RO' : 'RO',
  'SK' : 'SK',
  'SI' : 'SI',
  'ES' : 'ES',
  'SE' : 'SE',
};



// WEBPACK FOOTER //
// ./src/organisms/MainShop/constants.js